import { useContext, useEffect, useRef, useState } from "react";
import { Form, Button, Steps, notification, ConfigProvider, Card, Space } from "antd";
import { useTranslation } from "react-i18next";
import GlobalContext from "../../../context/GlobalContext";
// import classes from "./LancementSessionFormation.module.css";
import dayjs from "dayjs";
import { useLocation, useNavigate } from "react-router-dom";
import EtapeDonneesGenerales from "./Etapes/EtapeDonneesGenerales/EtapeDonneesGenerales";
import EtapeAffectationModule from "./Etapes/EtapeAffectationModule/EtapeAffectationModule";
import EtapeRecapitulatif from "./Etapes/EtapeRecapitulatif/EtapeRecapitulatif";
import { addAffaire, addCanlendrierToSession, generate_numero_groupe, getCalendrierRepartitionChronologique, getDetailsEpfByDirector, saveAffaire } from "../../../api/geoprod";
import { useLoader } from "../../../context/LoaderContext";
import EtapeRepartitionChronologique from "./Etapes/EtapeRepartitionChronologique/EtapeRepartitionChronologique";
import DeleteBrouillonModal from "../../Etablissements/CreateEpf/Modals/DeleteBrouillonModal";
import { Save, Trash2 } from "lucide-react";
import classes from "../../Etablissements/CreateEpf/CreateEpf.module.css";
const LancementSessionFormation = () => {
  const formatDate = (date) => dayjs(date).format("DD/MM/YYYY");
  const [form] = Form.useForm();
  const { globalData, setGlobalData , currentStep, setCurrentStep ,    setNbrBrouillon} = useContext(GlobalContext);
  const { t } = useTranslation();
    const [confirmModal, setConfirmModal] = useState(false);

   const navigate = useNavigate();
  
  
  const ref = useRef();
  const params = useLocation();
  const dataHomologation = params?.state?.dataHomologation;
  

 const { setIsLoading } = useLoader();


 


   
  const steps = [
    {
      title: (
        <>
          <div>Données Générales</div>
          <div style={{ fontSize: 12, color: 'gray' }}>Informations de base</div>
        </>
      ),
        content:<EtapeDonneesGenerales form={form}  id_session_formation_homologuee={params?.state?.id_session_formation_homologuee} setIsLoading={setIsLoading} id_formation={params?.state?.id_formation} registration_number={dataHomologation?.registration_number}/>,
    },
    {
      title: (
        <>
          <div>Périodes</div>
          <div style={{ fontSize: 12, color: 'gray' }}>Répartition chronologique</div>
        </>
      ),
        content:<EtapeRepartitionChronologique  globalData={globalData} setGlobalData={setGlobalData} print={true} />,
    },

    {
      title: (
        <>
          <div>Formateurs</div>
          <div style={{ fontSize: 12, color: 'gray' }}>Affectation des formateurs</div>
        </>
      ),
        content:<EtapeAffectationModule globalData={globalData} recap={false}  setGlobalData={setGlobalData} id_session_formation_homologuee={params?.state?.id_session_formation_homologuee} setIsLoading={setIsLoading}/>,
    },
    {
      title: (
        <>
          <div>Récapitulatif</div>
          <div style={{ fontSize: 12, color: 'gray' }}>Validation finale</div>
        </>
      ),
        content:<EtapeRecapitulatif  globalData={globalData}  setGlobalData={setGlobalData}  id_session_formation_homologuee={params?.state?.id_session_formation_homologuee} setIsLoading={setIsLoading} />,
    }
  ]
  


 const saveCurrent = (value)=>
        {
              sessionStorage.setItem("globalData", JSON.stringify(value));
              sessionStorage.setItem("currentStep", currentStep + 1); 
              setGlobalData(value);
              setCurrentStep(currentStep + 1);
              setIsLoading(false)
        }
  const saveSession = () => {
    let x = { ...form.getFieldsValue(), ...dataHomologation , ...globalData};
    if( currentStep === 0)
     {
          x = {
          ...x,
          date_debut_session_formation:formatDate(x.date_debut_session_formation)
        }
        if(sessionStorage.getItem("consulter") === "true" ){
                  getCalendrierRepartitionChronologique( params?.state?.id_session_formation_homologuee || sessionStorage?.getItem("id_session_formation_homologuee"))
                  .then((response) => {
                    const calendrier = response?.message?.calendrier
                    const transformedDataStages = JSON.parse(sessionStorage?.getItem("globalData"))?.transformedDataStages;

                    const filteredStages = transformedDataStages.filter(item => item?.type !== "year");

                    const updatedStages = filteredStages?.map((item, index) => {
                      if (item?.date_debut_periode) {
                        return {
                          ...item,
                          date_debut_periode: dayjs(calendrier[index]?.date_debut,"YYYY-MM-DD")?.format("DD/MM/YYYY") ,
                          date_fin_periode: dayjs(calendrier[index]?.date_fin,"YYYY-MM-DD")?.format("DD/MM/YYYY") ,
                        };
                      }
                      return item;
                    });
                       x = {
                                ...x,
                              transformedDataStages: updatedStages,
                        };
                         saveCurrent(x)
              
                  })
                .catch((error) => {
                  notification.error({
                  message: t("Erreur"),
                  description:
                    error?.data?.message,
                  duration: 0,
                });
                  setIsLoading(false)
                });
     }
     else {
      saveCurrent(x)
     }
    }
    else {
       saveCurrent(x)
     }

    }
  


   
  const items = steps.map((item, index) => ({
    key: index.toString(),
    title: item.title,
  }));



  const nextStep = async () => {
    if (currentStep < steps.length - 1) {
      setIsLoading(true)
      saveSession();
    }
     else
         {
          setIsLoading(true);
          const globalDataSession = JSON.parse(sessionStorage?.getItem("globalData"))
          const list_formateurs = globalDataSession?.affectationModules?.map(m => m?.Formateur)?.reduce((acc, id) => acc?.includes(id) ? acc : [...acc, id], []) || []
           const fieldsPannelOneStepOne = [
            {
              label: t("Secteur"),
              type: "text",
              value: globalData["secteur"],
            },
            {
              label: t("Sous-secteur"),
              type: "text",
              value: globalData["sous_secteur"],
            },
            {
              label: t("Spécialité"),
              type: "text",
              value: globalData["specialite"],
            },
            {
              label: t("Niveau minimal exigé pour la participation"),
              type: "text",
              value: globalData["niveau_requis"],
            },
            {
              label: t("Diplôme délivrée à la fin de la session"),
              type: "text",
              value: globalData["diplome"],
            },
          
            {
              label: t("Capacité générale (en personnes)"),
              type: "text",
              value: globalData["capacite_generale"],
            },
            {
              label: t("Numéro du groupe"),
              type: "text",
              value: globalData["num_grp"],
            },
          ];
          const fieldsPannelTwoStepTwo = [
            {
              label: t("Date de début de la session de formation"),
              type: "text",
              value: globalData["date_debut_session_formation"],
            },
            {
              label: t("Cette session de formation est-elle concernée par le Chèque Formation ?"),
              type: "radio",
              value: globalData["cheque_formation"],
              options: ["Oui", "Non"],
            },
           
                    
          ];
          
          const columnsTabStepTwo = [
            { title: "Période", dataIndex: "periode"},
            { title: "Semaine", dataIndex: "week"},
            { title: "Date de début", dataIndex: "date_debut"},
            { title: "Date de fin", dataIndex: "date_fin"},
          ];

      
          const moduleColumns = globalDataSession?.modules_formation[0]?.items?.map((mod, idx) => ({
            title: mod?.code_module,
            dataIndex: mod?.code_module,
            hover:mod?.intitulé,
          
          }));

          columnsTabStepTwo?.push(...moduleColumns);
      
          columnsTabStepTwo?.push({ title: "Charge hebdo", dataIndex: "charge_hebdo" });
      
       
          const data = [];

let currentYearLabel = "";

globalDataSession?.transformedDataStages?.forEach((row) => {
  if (row?.type === "year") {
    currentYearLabel = row.yearLabel;
  } else {
    const dataRow = {
      annee: currentYearLabel, 
      periode: row?.periode,
      week:
        row?.type === "special"
          ? row?.label
          : `Semaine formation N°${row?.weekIndex + 1}`,
      date_debut: row?.date_debut_periode,
      date_fin: row?.date_fin_periode,
    };

    if (row?.type === "special") {
      dataRow.specialType = row?.specialType;
      if (row?.specialType === "stage") {
        const st = row?.typeStage?.stageType;
        const nb =
          st === "intégration"
            ? Number(globalDataSession?.duree_stage_mois_observation) * 4
            : st === "observation"
            ? Number(globalDataSession?.duree_stage_mois_integration) * 4
            : 0;
        dataRow.charge_hebdo = `Stage – ${st} – ${nb} semaines`;
      } else {
        // debugger
        const nbJours =
          row.specialType === "rattrapage"
            ? row?.typeStage?.nbre_rattrapage_periode
            : row.specialType === "examen"
            ? row?.typeStage?.nbre_examen_periode
            : row?.typeStage?.nbre_vacances_periode;
        dataRow.charge_hebdo = `${
              row?.specialType === "examen"
              ? "Évaluation"
              : row?.specialType === "rattrapage"
              ? "Rattrapage"
              : row?.specialType
          } – ${nbJours} jours`;
      }
    } 
    else {
      dataRow.charge_hebdo =  `${row?.chargeHebdo} h`;
       dataRow.modules = row?.modulesStructred
    }

    data.push(dataRow);
  }
});

console.log(data);

    
                const dataJson = [
                  {
                    title: t("Données Générales"),
                    subtitle: t("Informations de base"),
                    type: "form",
                    sections: [
                      {
                        fields: fieldsPannelOneStepOne,
                        name: "Informations par défaut de la session",
                        type: "pannel"
                      },
                      {
                        fields: fieldsPannelTwoStepTwo,
                        name: "Données à configurer pour la session",
                        type: "pannel"
                      },
                    ],
                  },
                  {
                    title: t("Périodes"),
                    subtitle: t("Répartition chronologique"),
                    type: "form",
                    sections: [
                      {
                        fields: [
                          {
                            columns: columnsTabStepTwo,
                            rows: data,
                            type: "table",
                          }
                        ],
                      },
                    ],
                  },
                  {
                    title: t("Formateurs"),
                    subtitle: t("Affectation des formateurs"),
                    type: "form",
                    sections: [
                      {
                        fields: [
                          {
                            columns: [
                              { dataIndex: "periode", title: "Période" },
                              { dataIndex: "module", title: "Module" },
                              { dataIndex: "semaines", title: "Semaines" },
                              // {
                              //   title: "Profil",
                              //   dataIndex: "profil",
                              //   children: [
                              //     { dataIndex: "competences", title: "Compétences" },
                              //     { dataIndex: "diplomes", title: "Diplômes" }
                              //   ]
                              // },
                              { dataIndex: "competences", title: "Compétences" },
                              { dataIndex: "diplomes", title: "Diplômes" },
                              { dataIndex: "formateur", title: "Formateur" }
                            ],
                            rows: globalDataSession?.affectationModules?.map(item => ({
                              periode: item?.Semestre,
                              module: {
                                title: item?.moduleId || "",
                                hover: item?.Module || ""
                              },
                              semaines: item?.Semaines || "",
                              competences: item?.competences || "",
                              diplomes: item?.diplomes || "",
                              // profil: {
                              //   children: {
                              //     competences: item?.competences || [],
                              //     diplomes: item?.diplomes || []
                              //   }
                              // },
                              formateur: item?.Formateur || ""
                            })),
                            type: "table"
                          }
                        ]
                      }
                    ]
                  }
                  
                ];
          
                const payload = {
                  current_step: 0,
                  additional_form: "{}",
                  json_prod: {
                    ...params.state.dataHomologation,
                    ...form.getFieldsValue(),
                    ...globalDataSession,
                    dataJson: dataJson,
                    establishment_data_training_type:dataHomologation?.data_form?.establishment_data_training_type,
                    id_formation_session: params?.state?.id_formation,
                    max_apprenant:dataHomologation?.capacite_acceuil_annuelle,
                    max_semaine:dataHomologation?.duree_effective_totale,

                  },
                  list_formateur :list_formateurs,
                  registration_number : globalDataSession?.registration_number,
                  date_debut_session : globalDataSession?.date_debut_session_formation ? globalDataSession?.date_debut_session_formation : "",
                  date_fin_session : globalDataSession?.date_fin_session_formation ? globalDataSession?.date_fin_session_formation : ""
                };
                const dataAddCalendrier = data.map(({ week, charge_hebdo, date_debut, date_fin, periode,annee, specialType,modules }) => {
                  const result = { week, charge_hebdo, date_debut, date_fin, periode,annee };
                  if (specialType) {
                    result.specialType = specialType;
                    result.modules = [];
                  }
                  else
                  {
                    result.modules = modules;
                  }
                  return result;
                });
           
             


const moduleLastSemestreMap = {}; 

globalDataSession?.modules_planning?.forEach((entry, index) => {
  const semestreKey = Object.keys(entry)[0];
  const modulesObj = entry[semestreKey];

  Object.keys(modulesObj).forEach((code_module) => {
    const hasContent = modulesObj[code_module]?.some(v => v !== 0);
    if (hasContent) {
      moduleLastSemestreMap[code_module] = index;
    }
  });
});
const payloadClendrier = {
  id_affaire: sessionStorage.getItem("id_session_formation_homologuee"),
  calendrier: dataAddCalendrier,
 modules: globalDataSession?.modules_planning?.map((entry, index) => {
    const semestreKey = Object.keys(entry)[0];
    const modulesObj = entry[semestreKey];

    const validModules = Object.entries(modulesObj)
      .filter(([code_module, values]) => values.some(v => v !== 0)) 
      .map(([code_module]) => {
        const moduleInfo = globalDataSession?.modules_formation?.[0]?.items?.find(
          item => item.code_module?.trim() === code_module?.trim()
        );
        const isLastSemestre = moduleLastSemestreMap[code_module] === index;
        return {
          id: code_module,
          name: moduleInfo?.intitulé?.[0],
          seuil: moduleInfo?.seuil_réussite_value,
          unite_seuil: moduleInfo?.seuil_réussite,
          possede_examen: isLastSemestre ? 1 : 0,
        };
      });

    return {
      periode: semestreKey,
      module: validModules,
    };
  }),
};
                
                const responseSaveAffaire = await saveAffaire(
                  payload,
                  "soumissionSessionFormationHomologuee",
                  setIsLoading,
                  "session_formation_homologuee"
                );
                
                if (responseSaveAffaire) {
                 setIsLoading(true);
                  addCanlendrierToSession(payloadClendrier)
                        .then( (response) => {
                            sessionStorage.removeItem("currentStep");
                            sessionStorage.removeItem("id_session_formation_homologuee");
                            navigate("/demandes");
                            setIsLoading(false);
                        })
                        .catch((error)=>{
 setIsLoading(false);
   notification.error({
          message: t("Erreur"),
          description: t(error?.data?.message),
        duration: 0,
      });
                        })

                }
        }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
      sessionStorage.setItem("currentStep", (currentStep - 1).toString());
    }
  };

  const handleClickOutside = async (event) => {
    const globalDataSession = JSON.parse(sessionStorage.getItem("globalData"))
    const list_formateurs = globalDataSession?.affectationModules?.map(m => m?.Formateur)?.reduce((acc, id) => acc?.includes(id) ? acc : [...acc, id], []) || []
    if (
      ref.current &&
      !ref?.current?.contains(event?.target) &&
      !params?.state?.id_session_formation_homologuee
    ) {
      const payload = {
        current_step:  Number(sessionStorage.getItem("currentStep")) || currentStep,
        json_prod: {
          ...params.state.dataHomologation,
          ...form.getFieldsValue(),
          ...globalDataSession,
          establishment_data_training_type:dataHomologation?.data_form?.establishment_data_training_type,
          max_apprenant:dataHomologation?.capacite_acceuil_annuelle,
          max_semaine:dataHomologation?.duree_effective_totale,
        },
        list_formateur :  list_formateurs,
        registration_number : dataHomologation?.registration_number,
        date_debut_session : form.getFieldsValue()["date_debut_session_formation"] ?  dayjs(form.getFieldsValue()["date_debut_session_formation"]).format("DD/MM/YYYY") : globalDataSession
        ?.date_debut_session_formation ? globalDataSession
        ?.date_debut_session_formation : "",
        date_fin_session : globalDataSession
        ?.date_fin_session_formation ? globalDataSession
        ?.date_fin_session_formation : ""
      };
      if (form.getFieldsValue()["date_debut_session_formation"]) {
        payload.json_prod.date_debut_session_formation = formatDate(form.getFieldsValue()["date_debut_session_formation"])
      }
      // if (form.getFieldsValue()["date_fin_homologation"]) {
      //   payload.json_prod.date_fin_homologation = formatDate(form.getFieldsValue()["date_fin_homologation"])
      // }
      sessionStorage.setItem("payload", JSON.stringify(payload));


    }

  };

  const lancementSessionFormation = async () => {
    setIsLoading(true)
            getDetailsEpfByDirector()
                .then(async (responseDetailsEpf) => {
                  const json_prod = {
                    registration_number: responseDetailsEpf?.data?.message?.registration_number,
                    establishment_data_training_type:responseDetailsEpf?.data?.message?.establishment_data_training_type,
                    establishment_data_commercial_name: responseDetailsEpf?.data?.message?.establishment_data_commercial_name,
                    establishment_data_official_name: responseDetailsEpf?.data?.message?.establishment_data_official_name,
                    legal_entity_official_name: responseDetailsEpf?.data?.message?.legal_entity_official_name,
                    establishment_director_data_last_name: responseDetailsEpf?.data?.message?.establishment_director_data_last_name,
                    establishment_director_data_first_name: responseDetailsEpf?.data?.message?.establishment_director_data_first_name,
                    establishment_data_governorate: responseDetailsEpf?.data?.message?.establishment_data_governorate,
                    establishment_data_delegation: responseDetailsEpf?.data?.message?.establishment_data_delegation,
                    establishment_data_tax_number: responseDetailsEpf?.data?.message?.establishment_data_tax_number,
                    legal_entity_tax_number:responseDetailsEpf?.data?.message?.legal_entity_tax_number,
                    numero_matricule_fiscal_numero_IURNE:responseDetailsEpf?.data?.message?.data_form?.numero_matricule_fiscal_numero_IURNE,
                    numero_matricule_fiscal_IURNE:responseDetailsEpf?.data?.message?.numero_matricule_fiscal_IURNE,
                    ///////// ***////
                    establishment_director_data_phone_number:responseDetailsEpf?.data?.message?.establishment_director_data_phone_number,
                    max_apprenant:dataHomologation?.capacite_acceuil_annuelle,
                    max_semaine:dataHomologation?.duree_effective_totale,
                        ...globalData,
                        ...form.getFieldsValue(),
                        ...dataHomologation,
                        id_formation_session: params?.state?.id_formation,

              
                  };
                  const payload_add_affaire = {
                    ligne_produit: import.meta.env.VITE_APP_ID_LIGNE_PRODUIT_DEMANDE_CREATION_SESSION_FORMATION_HOMOLOGUEE,
                    id_opp: null,
                    nom_produit: "THAMM PRODUCT (  )",
                    id_produit: "d728587fff2d87201eae0a158507d814",
                    cmp: "987654300",
                    affaire_parent: "",
                    current_step: 0,
                    user_id: JSON.parse(localStorage.getItem("-x-token-user"))
                      .id_user,
                    date_effet: "2024-01-02",
                    souscription: "2024-01-02",
                    id_fractionnement: 11,
                    affected: "1002237",
                    id_formation: params?.state?.id_formation,
                    registration_number: responseDetailsEpf?.data?.message?.registration_number ,
                    data_form_prod: JSON.stringify(json_prod),
                   
                  };
                  const data = await addAffaire(payload_add_affaire,"soumission", null);
                  if (data) {
                    // setIsLoading(false);
              
                    sessionStorage.setItem("id_session_formation_homologuee", data?.id_affaire);

                    generate_numero_groupe({
                          id_affaire: data?.id_affaire,
                          id_formation: params?.state?.id_formation.toString(),
                          registration_number: responseDetailsEpf?.data?.message?.registration_number,
                        })
                          .then((responseAddNotes) => {
                            form.setFieldsValue({
                              ...form.getFieldsValue(),
                              num_grp: responseAddNotes?.message,
                            });
                            setIsLoading(false);
                          })
                          .catch((error) => {
                            notification?.error({
                              message: t("Erreur"),
                              description: t(error?.data?.message),
                              duration: 0,
                            });
                            // setIsLoading(false);
                          });
                  }
                 
                })
                .catch((error) => {
                  notification.error({
                    message: t("Erreur"),
                    description: t(error?.data?.message),
                    duration: 0,
                  });
                  setIsLoading(false);
                });
  };

 
  useEffect(() => {
    // debugger
    form?.setFieldsValue(
      JSON?.parse(sessionStorage?.getItem("globalData"))
        ? {
            ...JSON?.parse(sessionStorage?.getItem("globalData")),
            date_debut_session_formation: JSON.parse(sessionStorage?.getItem("globalData"))
            ?.date_debut_session_formation
            ?  dayjs(JSON?.parse(sessionStorage?.getItem("globalData"))?.date_debut_session_formation,"DD/MM/YYYY")
            :null,
          }
        : {
          ...form?.getFieldsValue(),
          secteur:dataHomologation?.Secteur,
          sous_secteur:dataHomologation?.sousSecteur,
          specialite:dataHomologation?.specialite,
          niveau_requis:dataHomologation?.niveau,
          diplome:dataHomologation?.diplome,
          // date_fin_homologation:dayjs(),
          capacite_generale:dataHomologation?.capacite_acceuil_annuelle,
          // num_grp:"1",
      
          }
    );
   

    setGlobalData(JSON?.parse(sessionStorage?.getItem("globalData")));
    // debugger
    if (!params?.state?.brouillon && !params?.state?.id_session_formation_homologuee && !sessionStorage?.getItem("id_session_formation_homologuee")) {
      lancementSessionFormation();
      
    }



    if (!params?.state?.id_affaire && !params?.state?.id_session_formation_homologuee) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };





  }, []);
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#195A99",
          lineWidth: 1,
          fontFamily: "open sans, Helvetica, Arial, sans-serif"
        },
        components: {
          DatePicker: { colorBorder: "#195A99", colorPrimaryHover: "#195A99" },
          Radio: { colorPrimary: "#195A99" },
          Input: {
            lineWidth: 2,
            colorBorder: "#195A99",
            colorPrimaryHover: "#195A99",
            colorPrimary: "#195A99",
            controlHeight: 45,
            fontSize: 14,
            colorText: "#000",
          },
          Select: {
            // lineWidth: 2,
            fontSize: 13,
            colorPrimaryHover: "#195A99",
          },

          // Steps: {
           
          //   iconFontSize: 16,
          //   iconSize: 38,
          // },
        },
      }}
    >
    <Card
      ref={ref}
      title={
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>Lancement d'une session de formation homologuée</span>
        </div>
      }
      bordered={false}
      style={{
        margin: "auto",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      }}
    >
       {/* <Spin spinning={isLoading} tip="" style={{ width: "100%" }}> */}
        <Form
          noValidate
          form={form}
          layout="vertical"
          onFinish={nextStep}
          onFinishFailed={() => {
            notification.error({
              message: t("Erreur"),
              description: t("Veuillez remplir tous les champs obligatoires."),
              duration: 0,
            });
          }}
          onKeyDown={(e) => (e.key === "Enter" ? e.preventDefault() : null)}
        >
          <Steps current={currentStep} items={items}  progressDot  className="stepper" 
          />
          <div className={classes?.contentStyle}>
            {steps[currentStep]?.content}
          </div>
          <div style={{ marginTop: "20px" , display:"flex", justifyContent:"space-between"}}>
              <Button
                onClick={prevStep}
                style={{ marginInline: "1rem" }}
                disabled={currentStep <= 0}
              >
                {t('Précédent')} 
              </Button>
            <Button type="primary" htmlType="submit" disabled={params?.state?.id_session_formation_homologuee && currentStep===3}>
            {currentStep < steps.length - 1 ? t('Suivant') : t('Soumettre')}
          </Button>
          
    </div>
    <div  style={{ marginBlock: "20px", display: "flex", justifyContent: "flex-end" }}>
{
  !params?.state?.id_session_formation_homologuee && (
    <Space>
            <Button
              className={classes.buttonCancel}
              onClick={() => setConfirmModal(true)}
              disabled={params?.state?.id_session_formation_homologuee}
            >
              <Trash2 strokeWidth={1.25} />
              {t("Annuler la demande")}
            </Button>
            <Button
              className={classes.buttonCreate}
               disabled={params?.state?.id_session_formation_homologuee}
              onClick={async () => {

                  const globalDataSession = JSON.parse(sessionStorage.getItem("globalData"))
                 const list_formateurs = globalDataSession?.affectationModules?.map(m => m?.Formateur)?.reduce((acc, id) => acc?.includes(id) ? acc : [...acc, id], []) || []

                 const payload = {
        current_step:  Number(sessionStorage.getItem("currentStep")) || currentStep,
        json_prod: {
          ...params.state.dataHomologation,
          ...form.getFieldsValue(),
          ...globalDataSession,
          establishment_data_training_type:dataHomologation?.data_form?.establishment_data_training_type,
          max_apprenant:dataHomologation?.capacite_acceuil_annuelle,
          max_semaine:dataHomologation?.duree_effective_totale,
        },
        list_formateur :  list_formateurs,
        registration_number : dataHomologation?.registration_number,
        date_debut_session : form.getFieldsValue()["date_debut_session_formation"] ?  dayjs(form.getFieldsValue()["date_debut_session_formation"]).format("DD/MM/YYYY") : globalDataSession
        ?.date_debut_session_formation ? globalDataSession
        ?.date_debut_session_formation : "",
        date_fin_session : globalDataSession
        ?.date_fin_session_formation ? globalDataSession
        ?.date_fin_session_formation : ""
      };
      if (form.getFieldsValue()["date_debut_session_formation"]) {
        payload.json_prod.date_debut_session_formation = formatDate(form.getFieldsValue()["date_debut_session_formation"])
      }
      setIsLoading(true)
                await saveAffaire(
                  payload,
                  "Brouillon",
                  setIsLoading,
                  "session_formation_homologuee"
                );
                sessionStorage.removeItem("currentStep");
                setNbrBrouillon((prevDataSource) => {
                  if (prevDataSource >= 1) {
                    return prevDataSource + 1;
                  }
                });
                navigate("/brouillon");
                 setIsLoading(false)
              }}
            >
              <Save strokeWidth={1.25} />
              {t("Sauvegarder au brouillon")}
            </Button>
          </Space>
  )
}
    
          </div>
        </Form>
      </Card>

 
    <DeleteBrouillonModal
        confirmModal={confirmModal}
        setConfirmModal={setConfirmModal}
        typeAffaire="session_formation_homologuee"
      />
     
      
    </ConfigProvider>
  );
};

export default LancementSessionFormation;
